import React from 'react';
import {translations} from 'presentation/translations-new';
import {formatText} from 'presentation/utils';
import {usePersonalData} from 'presentation/hooks';
import {StyledStack} from './styles';
import {BeneficiaryInfoProps} from './types';
import {DataContentCard} from '../DataContentCard';

const {beneficiaryTitle, orderNumberTitle, locationTitle} =
	translations['pt-br'].privateFlow.examResults.drawer;

export const BeneficiaryInfo = ({orderNumber, location}: BeneficiaryInfoProps) => {
	const {userName} = usePersonalData();
	return (
		<StyledStack>
			<DataContentCard
				iconName="person-outline"
				title={beneficiaryTitle}
				description={formatText(userName)}
			/>
			<DataContentCard
				iconName="assignment-outline"
				title={orderNumberTitle}
				description={orderNumber}
			/>

			<DataContentCard
				iconName="map-default"
				title={locationTitle}
				description={formatText(location)}
			/>
		</StyledStack>
	);
};
